import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { useTranslation } from "react-i18next";

type TransientResponseActionsProps = {
  isLastStep: boolean;
  isTriggering?: boolean;
  onBack: () => void;
  onCancel: () => void;
  onNext: () => void;
  onTrigger: () => void;
  showBack: boolean;
};

export const TransientResponseActions = ({
  isLastStep,
  isTriggering = false,
  onBack,
  onCancel,
  onNext,
  onTrigger,
  showBack,
}: TransientResponseActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="bg-lds-surface-muted px-10 py-3 border-t-ds-strong">
      <Stack className="justify-between">
        {showBack ? (
          <Button disabled={isTriggering} onClick={onBack} variant="tertiary">
            {t("general.back")}
          </Button>
        ) : (
          <span />
        )}
        <Stack className="gap-4">
          <Button disabled={isTriggering} onClick={onCancel} variant="secondary">
            {t("general.cancel")}
          </Button>
          {/* <Button disabled={isTriggering} isLoading={isSaving} onClick={onSave} variant="tertiary">
            {t("Execution.transient.actions.save")}
          </Button> */}
          {isLastStep ? (
            <Button disabled={isTriggering} isLoading={isTriggering} onClick={onTrigger}>
              {t("Execution.transient.actions.trigger")}
            </Button>
          ) : (
            <Button disabled={isTriggering} onClick={onNext}>
              {t("general.next")}
            </Button>
          )}
        </Stack>
      </Stack>
    </div>
  );
};
